import React from 'react';

import { defineMessages, useIntl } from 'react-intl';
import styled from 'styled-components';

import { FloatingLabelSelect } from 'components/floating-label-fields';
import { getCountryOptions } from 'utils/form/constants';

import { IProps } from './types';

const CountryDisclaimer = styled.p`
  color: ${Styles.color.grey.two};
  font-family: ${Styles.fontFamily.body};
  font-size: 0.75rem;
  margin-top: -0.25rem;
`;

const CountrySelectInput = ({
  'data-testid': testId,
  value,
  onChange,
  label,
  disabled,
  name,
  message,
  validation,
  disclaimer
}: IProps<HTMLSelectElement>) => {
  const { formatMessage } = useIntl();
  const countryOptions = getCountryOptions(formatMessage);
  let options = [...countryOptions];

  if (value === '') {
    options = [{ value: '', label: formatMessage(messages.selectACountry) }, ...options];
  }

  return (
    <>
      <FloatingLabelSelect
        required
        label={label}
        name={name}
        value={value}
        options={options}
        onChange={onChange}
        disabled={disabled}
        message={message}
        validation={validation}
        data-testid={testId}
      />
      {disclaimer && (
        <CountryDisclaimer data-testid="country-input-disclaimer">{disclaimer}</CountryDisclaimer>
      )}
    </>
  );
};

export default CountrySelectInput;
const messages = defineMessages({
  selectACountry: {
    id: 'selectACountry',
    defaultMessage: 'Select a country',
    description: 'Placeholder text for field if country had not been selected'
  }
});
